import { render } from "./afterMovies.vue?vue&type=template&id=1070e797"
const script = {}

import "./afterMovies.vue?vue&type=style&index=0&id=1070e797&lang=css"

import exportComponent from "/var/www/__turkey-24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__